import m from "../../../../geodata/es2015/region/usa/idHigh";
window.am4geodata_region_usa_idHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/idHigh.js
// module id = null
// module chunks = 